module.exports = __webpack_public_path__ + "img/hot.99978763.png";